import { useApiPrivateRequest } from "../../../shared/hooks/useApi";
import { LlmClientShort } from "../models/LlmClientShort";

export const useGetLlmClients = () => {
  const {
    data: llmClients,
    call,
    isLoading,
    isFailed,
  } = useApiPrivateRequest<LlmClientShort[]>((response) =>
    response.map((item: any) => new LlmClientShort(item)),
  );

  const getLlmClients = async (llmName: string) => {
    await call(`/admin/llm/${llmName}/clients`, "GET");
  };

  return {
    llmClients,
    getLlmClients,
    isLoading,
    isFailed,
  };
};
